import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Box } from '@mui/material';
import AccountSummaryCollapse from './AccountSummaryCollapse';

const useStyles = makeStyles((theme) => ({
  accordionSummaryCollapsed: {
    width: '100%',
  },
  itemBox: {
    '&&': {
      marginBottom: '10px',
      alignItems: 'start',
      '@media (max-width: 599px)': {
        display: 'flex',
      },
      '@media (min-width: 1201px)': {
        display: 'flex',
      },
    },
  },
  itemBoxWrap: {
    '&&': {
      marginBottom: '10px',
      alignItems: 'start',
      '@media (max-width: 599px)': {
        display: 'flex',
      },
      '@media (min-width: 1500px)': {
        display: 'flex',
      },
    },
  },
  itemSubtitle: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#56657E',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.32px',
      textAlign: 'left',
      width: '130px',
      whiteSpace: 'nowrap',
    },
  },
  itemBody: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '20px',
      letterSpacing: '0.32px',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
  },
  subtitleColumn2: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#56657E',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.32px',
      textAlign: 'left',
      width: '110px',
      whiteSpace: 'nowrap',
    },
  },
  bodyColumn2: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '20px',
      letterSpacing: '0.32px',
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
  },
  paperItems: {
    '&&': {
      padding: '10px',
      // flex: 1,
      border: 'none !important',
      boxShadow: 'none !important',
    },
  },
}));
const AccountSummaryExpand = ({
  accountSummaryData,
  handleNote,
  handleFile,
  refreshNotes,
  importFileForm,
  handleClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.accordionSummaryCollapsed}>
      <Paper className={classes.paperItems}>
        <Grid container sx={{ width: '100%' }}>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Account Owner:</Typography>
              <Typography className={classes.itemBody}> {accountSummaryData.collector} </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Mobile:</Typography>
              <Typography className={classes.itemBody}> {accountSummaryData.phone} </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Home Phone:</Typography>
              <Typography className={classes.itemBody}> {accountSummaryData.phone} </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={[classes.itemSubtitle, classes.subtitleColumn2]}>
                MRN:
              </Typography>
              <Typography className={[classes.itemBody, classes.bodyColumn2]}>
                {' '}
                {accountSummaryData.mrnNum}{' '}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={[classes.itemSubtitle, classes.subtitleColumn2]}>
                Client Code:
              </Typography>
              <Typography className={[classes.itemBody, classes.bodyColumn2]}>
                {' '}
                {accountSummaryData.clientNumber}{' '}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBoxWrap}>
              <Typography className={[classes.itemSubtitle, classes.subtitleColumn2]}>
                Client Name:
              </Typography>
              <Typography
                className={[classes.itemBody, classes.bodyColumn2]}
                sx={{ whiteSpace: 'normal !important' }}
              >
                {' '}
                {accountSummaryData.clientName}{' '}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Placement Date:</Typography>
              <Typography className={classes.itemBody}>
                {' '}
                {accountSummaryData.placementDate}{' '}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Service Date:</Typography>
              <Typography className={classes.itemBody}>
                {' '}
                {accountSummaryData.serviceDate}{' '}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Days in Agency:</Typography>
              <Typography className={classes.itemBody}>
                {' '}
                {accountSummaryData.daysInAgency}{' '}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Iep Start - End:</Typography>
              <Typography className={classes.itemBody}>
                {accountSummaryData.startEndDate}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Initial Balance:</Typography>
              <Typography className={classes.itemBody}>
                {' '}
                {accountSummaryData.listBalance}{' '}
              </Typography>
            </Box>
            <Box alignItems="center" className={classes.itemBox}>
              <Typography className={classes.itemSubtitle}>Current Balance:</Typography>
              <Typography className={classes.itemBody}> {accountSummaryData.balance} </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <AccountSummaryCollapse
        accountSummaryData={accountSummaryData}
        collapse={false}
        handleNote={handleNote}
        handleFile={handleFile}
        refreshNotes={refreshNotes}
        importFileForm={importFileForm}
        handleClick={handleClick}
      />
    </div>
  );
};

export default AccountSummaryExpand;
